import { render, staticRenderFns } from "./FileType.vue?vue&type=template&id=32426cac&scoped=true"
import script from "./FileType.vue?vue&type=script&lang=js"
export * from "./FileType.vue?vue&type=script&lang=js"
import style0 from "./FileType.vue?vue&type=style&index=0&id=32426cac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32426cac",
  null
  
)

export default component.exports